import { Controller } from '@hotwired/stimulus'
/** Specialized controller for the referral wizard's referral step.
The school avoidance has a few special behaviors that need to be handled here.
High level, when user selects the school avoidance concern, it will automatically
trigger enrollment into the program. The enrollment requires BOTH IT and PG services. **/
export default class extends Controller {
  static targets = [
    'yesInProgramRadio',
    'noInProgramRadio',
    'programRequiredServices',
    'schoolAvoidanceInfoSection',
    'schoolAvoidanceConcern',
    'nonProgramServices',
  ]

  connect() {
    this.updateEnrollment()
    this.updateReferralConcern()
  }

  findLabel(checkBoxEl) {
    return checkBoxEl.closest('label') || document.querySelector(`label[for="${checkBoxEl.id}"]`)
  }

  disableServiceOptions(checkBoxEl) {
    checkBoxEl.checked = false
    checkBoxEl.disabled = true
    checkBoxEl.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none')

    const checkBoxLabel = this.findLabel(checkBoxEl)
    if (checkBoxLabel) {
      checkBoxLabel.classList.add('cursor-not-allowed', 'pointer-events-none', 'text-charcoal-50')
    }
  }

  requireServiceOptions(checkBoxEl) {
    checkBoxEl.checked = true
    // Avoiding the disabled attribute so we can still submit the services
    checkBoxEl.classList.add('opacity-50', 'cursor-not-allowed', 'pointer-events-none')

    // Update label too to avoid toggling value through a label click
    const checkBoxLabel = this.findLabel(checkBoxEl)

    if (checkBoxLabel) {
      checkBoxLabel.classList.add('cursor-not-allowed', 'pointer-events-none')
    }
  }

  resetServiceOptions(checkBoxEl) {
    checkBoxEl.checked = false
    checkBoxEl.disabled = false
    checkBoxEl.classList.remove('opacity-50', 'cursor-not-allowed', 'pointer-events-none')

    const checkBoxLabel = this.findLabel(checkBoxEl)
    if (checkBoxLabel)
      checkBoxLabel.classList.remove(
        'cursor-not-allowed',
        'pointer-events-none',
        'text-charcoal-50'
      )
  }

  updateEnrollment() {
    if (this.yesInProgramRadioTarget.checked) {
      this.nonProgramServicesTargets.forEach((serviceCheckbox) => {
        this.disableServiceOptions(serviceCheckbox)
      })

      this.programRequiredServicesTargets.forEach((serviceCheckbox) => {
        this.requireServiceOptions(serviceCheckbox)
      })
      // Only show school avoidance info announcement when enrollment is selected
      this.schoolAvoidanceInfoSectionTarget.classList.remove('hidden')
    } else if (this.noInProgramRadioTarget.checked) {
      this.nonProgramServicesTargets.forEach((serviceCheckbox) => {
        this.resetServiceOptions(serviceCheckbox)
      })

      this.programRequiredServicesTargets.forEach((serviceCheckbox) => {
        this.resetServiceOptions(serviceCheckbox)
      })
      // Only show school avoidance info announcement when enrollment is selected
      this.schoolAvoidanceInfoSectionTarget.classList.add('hidden')
    }
  }

  updateReferralConcern() {
    // Auto enroll client into School Avoidance program
    if (this.schoolAvoidanceConcernTarget.checked) {
      this.yesInProgramRadioTarget.checked = true
    }
    // Trigger the other updates when enrolled
    this.updateEnrollment()
  }
}
